export default __webpack_public_path__ + "static/media/protecao-pessoal.507bfe2a.png";